import DetailRrhhTravel from '@/requests/travels/rrhh/detailRequestRrhh'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/requests/viewTravel/$id/',
)({
  beforeLoad: ({ context }) => {
    if (!context.user) {
      throw redirect({ to: '/login' })
    }

    const { isAdmin, isRRHH, isSupervisor } = context.userRoles

    if (!isAdmin && !isRRHH && !isSupervisor) {
      throw redirect({ to: '/unauthorized' })
    }
  },

  component: TravelDetailPage,
})

function TravelDetailPage() {
  const { id } = Route.useParams()
  return <DetailRrhhTravel travelId={id} />
}